import axios from "axios"

const url = process.env.REACT_APP_URL

export const getSettings = async () => {
  try {
    const res = await axios.get(url + "/camera/getSettings", {})
    return res.data;
  } catch (err) {
    console.log(err)
    return err
  }
}

export const updateSettings = async (cameraId: string, trayDetection: boolean, photoOnly: boolean, isRefresh,
  resolution: { width: number, height: number, resolution: string } | undefined, uploadViaBackend?: boolean) => {
  try {
    const res = await axios.post(url + "/camera/updateSettings", {
      trayDetection: trayDetection,
      cameraId: cameraId,
      photoOnly: photoOnly,
      refresh: isRefresh,
      resolution,
      uploadViaBackend
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}